import React from 'react';

import { Alert, Button } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

type SolidaritySquadAlertProps = {
  onBtnClick: () => void;
};

function SolidaritySquadAlert({ onBtnClick }: SolidaritySquadAlertProps) {
  return (
    <Alert
      type='info'
      className='max-sm:flex-col max-sm:items-center'
      message={
        <>
          Colabore para transformar vidas e a comunidade por meio da educação, qualificação profissional e
          empreendedorismo.{' '}
          <a href='https://www.projetoelevar.org.br/' target='_blank' rel='noopener noreferrer'>
            Clique aqui para saber mais.
          </a>
        </>
      }
      action={
        <Button
          icon={<Icon.Heart />}
          block
          onClick={onBtnClick}
          variant='filled'
        >
          Quero colaborar
        </Button>
      }
    />
  );
}

export { SolidaritySquadAlert };
